import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { Col, Menu, Row, Skeleton } from 'antd'
import { DOC_REVIEW_DASHBOARD_PATH } from 'docReviewDashboard'

import deleteCannedMessage, {
  deleteCannedMessageData,
} from 'core/application/docReviewDashboard/cannedMessages/deleteCannedMessage'
import {
  CannedMessage,
  getForCannedMessagesView,
} from 'core/application/docReviewDashboard/cannedMessages/getForCannedMessagesView'

import notification from 'common/components/feedback/Notification'
import Button from 'common/components/general/Button'

import { commandRequest, queryRequest } from 'common/RequestUtils'

import { CANNED_MESSAGES_PATH } from '..'

import './viewCannedMessages.less'

const ViewCannedMessages: React.FC = () => {
  let history = useHistory()
  const [messages, setMessages] = useState<CannedMessage[]>([])
  const [content, setContent] = useState<string>('')
  const [messageId, setMessageId] = useState<string>('')
  const [clicked, setClicked] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const { t: translate } = useTranslation()

  const fetchData = async () => {
    setLoading(true)
    let data = await queryRequest(() => getForCannedMessagesView())
    if (data.length > 0) {
      setMessages(data)
      setContent(translate('doc-review-dashboard.canned-messages.default-message'))
    } else {
      setMessages([])
      setContent('')
      setClicked(false)
    }

    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [])

  const deleteMessage = async (messageToDeleteId: string) => {
    let dataToDelete: deleteCannedMessageData = {
      id: messageToDeleteId,
    }

    let result = await commandRequest(() => deleteCannedMessage(dataToDelete))

    if (!result.errors) {
      notification.open({
        message: translate('doc-review-dashboard.canned-messages.delete-success-message'),
        type: 'success',
      })
      fetchData()
    } else {
      notification.open({
        message: result.errors[0],
        type: 'error',
      })
    }
  }

  const getMessagesComponent = (messageTitles: CannedMessage[]) => {
    return (
      <Menu className="no-right-border">
        {messageTitles.map(({ id, title, message }: CannedMessage) => (
          <Menu.Item onClick={() => onClickTitle(id ?? '', message)} className="title-content-wrapper pt-8">
            {title}
          </Menu.Item>
        ))}
      </Menu>
    )
  }

  const onClickTitle = (messageId: string, content: string) => {
    setClicked(true)
    setContent(content)
    setMessageId(messageId)
  }

  return (
    <div className="super-wrapper">
      <Row className="inner-padding">
        <Col span={4} className="text-semi-bold">
          {translate('doc-review-dashboard.canned-messages.view-title')}
        </Col>
      </Row>
      <Skeleton loading={loading}>
        <Row className="inner-padding">
          <Col span={8} className="header-wrapper">
            <Row className="pb-8 bottom-border">
              <Col span={10}>{translate('doc-review-dashboard.canned-messages.view-message-header')}</Col>
            </Row>
            <Row>
              <Col span={24} className="pt-8">
                {getMessagesComponent(messages)}
              </Col>
            </Row>
          </Col>
          <Col span={16} className="header-wrapper pl-24">
            <Row className="pb-8 bottom-border">
              <Col>{translate('doc-review-dashboard.canned-messages.view-content-header')}</Col>
            </Row>
            <Row>
              <Col span={16} className="title-content-wrapper pt-20">
                {clicked ? (
                  <Row>
                    <Col>
                      <Row>
                        <div className="brake-line" dangerouslySetInnerHTML={{ __html: content }}></div>
                      </Row>
                      <Row className="flex fd-row mt-16">
                        <Col className="mr-16">
                          <Button
                            onClick={() => {
                              history.push(`${DOC_REVIEW_DASHBOARD_PATH}/${CANNED_MESSAGES_PATH}/${messageId}`)
                            }}
                            icon="fa fa-pencil-alt"
                            iconPosition="left"
                            type="primary"
                          >
                            {translate('general.edit')}
                          </Button>
                        </Col>
                        <Col>
                          <Button
                            onClick={() => {
                              deleteMessage(messageId)
                            }}
                            className="danger-button danger"
                            icon="fa fa-trash-alt"
                            iconPosition="left"
                          >
                            {translate('general.delete')}
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                  </Row>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Skeleton>
      <Row className="inner-padding">
        <Col span={4}>
          <Button
            onClick={() => {
              history.push(`${DOC_REVIEW_DASHBOARD_PATH}/${CANNED_MESSAGES_PATH}/add`)
            }}
            type="primary"
          >
            {translate('doc-review-dashboard.canned-messages.view-new-msg-button')}
          </Button>
        </Col>
      </Row>
    </div>
  )
}

export default ViewCannedMessages
